import React, { useEffect, useRef } from "react";
import { Button, Container, Navbar } from "react-bootstrap";
import logo from '../../components/logo/srma-logo.webp';
import '../../../src/pages/Website/webStyle.css'
import WebsiteNavbar from "./Navbar";
import aboutImg from '../../components/images/1000075508-01.png';
import MobileModel from '../../components/images/mobileim.png';
import playStore from '../../components/icons/playstore.png';
import appStore from '../../components/icons/app-store.png';
import installIcon from '../../components/icons/install.png';
import createIcon from '../../components/icons/add-friend.png';
import useIcon from '../../components/icons/smartphones.png';
import { Avatar } from "@mui/material";
import instaOutline from '../../components/icons/instagram-ot.png';
import fbOutline from '../../components/icons/facebook-ot.png';
import ytOutline from '../../components/icons/youtube-ot.png';
import Footer from "./footer";
import { Helmet } from "react-helmet-async";


export default function Home() {
    const videoRef = useRef(null);
    useEffect(() => {
        if (videoRef.current) {
        videoRef.current.playbackRate = 0.5;
        }
    }, []);


    const testimonials = [
        { id: 1, text: "We love Landingfolio! Our designers were using it for their projects, so clients already knew what Landingfolio was and how to use it.", name: "Mari" },
        { id: 2, text: "Landingfolio has made our design process so much easier. Clients love it!", name: "Priya" },
        { id: 3, text: "Great tool for designers and agencies. Highly recommended!", name: "Rahul" }
    ];

    return (
        <div>
            <Helmet>
                <title>Empowering your Business Future.</title>
            </Helmet>
            <WebsiteNavbar />
            <div className="banner">
                
                <video
                    ref={videoRef}
                    src="/assets/video/banner-video.webm"
                    autoPlay
                    muted
                    loop
                    style={{ width: '100%' }}
                    ></video>

                <div className="container h-100">
                    <div className="row h-100 align-items-center">
                        <div className="col-lg-8">
                            <div className="title">
                                <h1>Empowering your Business Future.</h1>
                            </div>
                            <div className="d-flex align-items-center mt-5 ResponsiveButton">
                                <div className="d-flex justify-content-center align-items-center storeButton pointer">
                                    <h5 className="mb-0">Get it on</h5>
                                    <img src={playStore} style={{ marginLeft: '20px' }} width='15%' />
                                </div>

                                <div className="d-flex justify-content-center align-items-center storeButton pointer" style={{ marginLeft: '25px' }}>
                                    <h5 className="mb-0">Get it on</h5>
                                    <img src={appStore} style={{ marginLeft: '20px' }} width='15%' />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 MobileImg">
                            <img src={MobileModel} />
                        </div>
                    </div>
                </div>
            </div>

            {/*How it works section */}

            <div className="container mt-5">
                <h1 className="text-center cagyTitle">HOW IT <span>WORKS</span></h1>
                <div className="row mt-5">
                    <div className="col-lg-4 px-5">
                        <div className="d-flex justify-content-center">
                            <img className="stepimg" src={installIcon} />
                        </div>
                        <h4 className="text-center mt-5">INSTALL APP</h4>
                        <p className="fs-18 text-center">Download the SRMA App from the Play Store and bring the entire textile market to your fingertips.</p>
                    </div>
                    <div className="col-lg-4 px-5">
                        <div className="d-flex justify-content-center">
                            <img className="stepimg" src={createIcon} />
                        </div>
                        <h4 className="text-center mt-5">CREATE AN ACCOUNT</h4>
                        <p className="fs-18 text-center">Join the trusted community of merchants by creating your free account in just a few clicks.</p>
                    </div>
                    <div className="col-lg-4 px-5">
                        <div className="d-flex justify-content-center">
                            <img className="stepimg" src={useIcon} />
                        </div>
                        <h4 className="text-center mt-5">ENJOY THE FEATURES</h4>
                        <p className="fs-18 text-center">Stay updated on market trends, connect with traders, access exclusive deals, and grow your textile business — all in one place.</p>
                    </div>
                </div>
            </div>

            {/*About us section */}

            <div className="aboutUs">
                <div className="container mt-5 pt-5">
                    <div className="row">
                        <div className="col-lg-4">
                            <div className="cagyTitle">
                                <h1 className="cagyTitle text-center">ABOUT</h1>
                                <h1 className="text-center span">SRMA</h1>
                            </div>
                        </div>

                        <div className="col-lg-8">
                            <ul style={{listStyleType:'none', fontSize: '18px', fontWeight: 600}}>
                                <li>SRMA (Singara Garden Ready Made Merchants Association) was established in 2007 to support over a thousand surplus garment manufacturers and traders.</li>
                                <li>Since its inception, SRMA has earned trust by offering guidance during critical periods like VAT implementation, GST transition, and currency fluctuations.</li>
                                <li>The association continues to be a strong backbone for the business community, providing leadership, support, and unity among traders.</li>
                            </ul>
                        </div>
                    </div>

                    <hr />

                    <div className="row">
                        <div className="col-lg-6">
                            <div className="d-flex justify-content-evenly">
                                <div>
                                    <div className="aboutCount">
                                        <h1 className="text-center">5K</h1>
                                        <h6 className="text-center">Active users</h6>
                                    </div>
                                    <div className="aboutCount">
                                        <h1 className="text-center">2K</h1>
                                        <h6 className="text-center">Downloads</h6>
                                    </div>
                                </div>
                                <div className="mt-5">
                                    <div className="aboutCount">
                                        <h1 className="text-center">15K</h1>
                                        <h6 className="text-center">Reviews</h6>
                                    </div>
                                    <div className="aboutCount">
                                        <h1 className="text-center">09</h1>
                                        <h6 className="text-center">Rewards</h6>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="d-flex justify-content-end">
                                <img className='aboutUsimg' src={MobileModel} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/*Testimonial section */}

            <div className="testimonial mt-5">
                <div className="container mt-5">
                    <div className="row">
                        <div className="w-100 cagyTitle d-flex justify-content-center mb-5" >
                            <h1 className="text-center w-50" style={{ fontWeight: '600' }}>KIND WORDS FROM OUR LOVELY <span>CUSTOMERS</span></h1>
                        </div>

                        {testimonials.map((testimonial, index) => (
                            <div key={testimonial.id} className="col-lg-4" style={{ padding: '38px 18px' }}>
                                <div
                                    className="cardDesign"
                                    style={{ transform: index % 2 === 0 ? "rotate(356deg)" : "rotate(2deg)" }}
                                >
                                    <h5>{testimonial.text}</h5>
                                    <hr />
                                    <div className="d-flex justify-content-between">
                                        <Avatar src='https://srma.digitaltriumph.co.in/public/storage/sellers/profile_pics/TMnt7T5Ltw2KeSVU819upZF6VRyiSg7aphI1YnAe.jpg'></Avatar>
                                        <h5>{testimonial.name}</h5>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <Footer />

        </div>
    )
}